<template>
  <div class="nhomepage">
    <TopNotice v-if="topNotices&&topNotices.length" :notices="topNotices" />
    <MidNotice v-if="midNotices&&midNotices.length" :notices="midNotices" />
    <div class="nhomepage-banner-area" v-if="bannerTexts&&bannerTexts.length">
      <BannerTexts :bannerTexts="bannerTexts" @bannerItemClicked="noticeClicked" />
    </div>
    <div class="nhomepage-banner-imgs" v-if="bannerImgs&&bannerImgs.length">
      <BannerImages :images="bannerImgs" @bannerItemClicked="noticeClicked" />
    </div>
    <div class="home-flex-row" v-if="hasServiceCard">
      <HomePageCard class="home-recomm-services" title="推荐服务">
        <template v-for="data in serviceItems">
          <ServiceItem :key="bizLineIdNum+data.name" v-if="data.icon!=='app'" @click.native="servicItemClicked(data)" :icon="data.icon" :name="data.name" :desc="data.desc" />
          <Tooltip v-if="data.icon==='app'" :key="data.name" placement="right">
            <ServiceItem :key="data.name" :icon="data.icon" :name="data.name" :desc="data.desc" :delay='350' />
            <img src="//p0.meituan.net/codeman/8acc947084d6b22070523f39dcb7c91428173.png" width='226px' slot="content" />
          </Tooltip>
        </template>
      </HomePageCard>
      <HomePageCard class="home-recomm-actives" title="推荐活动">
        <ul v-if="activeItems&&activeItems.length">
          <ActiveItem v-for="data in activeItems" :key="data.id" :name="data.name" :date="data.date" :bgclass="data.bg" />
        </ul>
        <div class="create-selfpro-tip" v-else>
          <div>
            <p class="main-desc">暂无可参加的活动</p>
            <p class="sub-desc">自己做促销，同样可以吸引顾客</p>
            <Button type="primary" @click="createSelfProClicked">创建自促活动</Button>
          </div>
        </div>
      </HomePageCard>
    </div>
    <div class="home-flex-row">
      <div class="nhomepage-notices">
        <Notices title='平台公告' :notices="notices" @extraClicked="moreNoticesClicked(3)" />
        <Notices title="规则中心" :notices="rules" @extraClicked="moreNoticesClicked(10)" />
      </div>
      <HomePageCard class="nhomepage-xigua-academy" title="西瓜学院" extra="更多" @extraClick="moreNoticesClicked(5)">
        <ul class="course-list">
          <CourseItem v-for="courseItem in courses" @click.native="noticeClicked(courseItem.id)" :key="courseItem.id" :src="courseItem.src" :title="courseItem.title" :subTitle="courseItem.subTitle" />
        </ul>
      </HomePageCard>
    </div>
    <HomePageFooter/>
  </div>
</template>
<script>
  import HomePageCard from "components/homepage/Card.vue";
  import ServiceItem from "components/homepage/serviceItem.vue";
  import ActiveItem from "components/homepage/ActiveItem.vue";
  import Notices from "components/homepage/notices.vue";
  import CourseItem from "components/homepage/CourseItem.vue";
  import HomePageFooter from "components/homepage/Footer.vue";
  import BannerTexts from "components/homepage/BannerTexts";
  import BannerImages from "components/homepage/BannerImages";
  import TopNotice from "components/homepage/TopNotice";
  import MidNotice from "components/homepage/MidNotices";
  import {
      getServiceItems,
      processServiceItem,
      openNoticeDetail,
      moreNotices,
      toCreateSelfPromotion,
      getDefaultData
  } from "components/nhomepage/utils";
  import { getAnnounces } from "api/nshared";
  export default {
      data: function() {
          return getDefaultData();
      },
      props: {
          bizLineId: {
              type: String,
              required: false
          }
      },
      created() {
          this.updateData(this.$route);
      },
      mounted() {
          this.unregisterRouteHookFn = this.$router.beforeEach((to, from, next) => {
              this.updateData(to, true);
              next();
          });
      },
      destroyed() {
          if (this.unregisterRouteHookFn) {
              this.unregisterRouteHookFn();
          }
      },
      components: {
          HomePageCard,
          ServiceItem,
          ActiveItem,
          Notices,
          CourseItem,
          HomePageFooter,
          BannerTexts,
          BannerImages,
          TopNotice,
          MidNotice
      },
      methods: {
          resetData() {
              Object.assign(this, getDefaultData());
          },
          updateData(route, notCreated) {
              if (notCreated) {
                  this.resetData();
              }
              this.bizLineIdNum = Number.parseInt(
                  this.bizLineId || route.meta.bizLineId
              );
              if (!this.bizLineIdNum) {
                  console.error("bizlineId should be a number!");
                  return;
              }
              this.serviceItems = getServiceItems(this.bizLineIdNum);
              this.hasServiceCard = this.serviceItems && this.serviceItems.length;
              this.getAnnounces();
          },
          servicItemClicked(item) {
              processServiceItem(item, this.$router);
          },
          getAnnounces() {
              getAnnounces(this.bizLineIdNum)
                  .then(notices => {
                      if (notices) {
                          if (notices.notices) {
                              this.notices = notices.notices;
                          }
                          if (notices.midDialogDecorateList) {
                              this.midNotices = notices.midDialogDecorateList;
                          }
                          if (notices.rules) {
                              this.rules = notices.rules;
                          }
                          if (notices.courses) {
                              this.courses = notices.courses;
                          }
                          if (notices.bannerTexts) {
                              this.bannerTexts = notices.bannerTexts;
                          }
                          if (notices.bannerImages) {
                              this.bannerImgs = notices.bannerImages;
                          }
                          if (notices.topNotices) {
                              this.topNotices = notices.topNotices;
                          }
                      }
                  })
                  .catch(err => {
                      let msg = (err && err.message) || "获取公告出错";
                      this.$Message.error(msg);
                  });
          },
          moreNoticesClicked(type) {
              moreNotices(type, this.bizLineIdNum, this.$router);
          },
          noticeClicked(id) {
              openNoticeDetail(id);
          },
          createSelfProClicked() {
              toCreateSelfPromotion(this.bizLineIdNum, this.$router);
          }
      }
  };
</script>
<style lang="scss">
@import "./../homepage/_common.scss";
$bgColor: #e9ecf2;
$mainPadding: 20px;
$cardMargin: 20px;
$serviceItemsHeight: 216px;
$serviceContentHeight: 126px;
$blockInnerMargin: 10px;
$academyHeight: 524px;
@mixin cardCommon {
  margin-bottom: $cardMargin;
}

@mixin noLastFlexCell {
  margin-right: $cardMargin;
}

@mixin cardBodyItems($name) {
  .tbo-card-body {
    display: flex;
    .#{$name} {
      @include flexCellCommon;
    }
  }
}

.nhomepage {
  .course-list {
        list-style-type: none;
   }
  .tbo-tooltip {
    @include flexCellCommon;
    text-align: center;
  }
  .nhomepage-banner-area,
  .nhomepage-banner-imgs {
    margin-bottom: $cardMargin;
  }
  .create-selfpro-tip {
    @include create-selfpro-tip;
  }
  background-color: $bgColor;
  padding: $mainPadding;
  .home-flex-row {
    display: flex;
    @include cardCommon;
    margin-bottom: $cardMargin;
    &:last-child {
      margin-bottom: 0;
    }
    .nhomepage-notices,
    .home-recomm-services {
      @include noLastFlexCell;
    }
    .home-recomm-services {
      @include cardBodyItems("service-item");
    }
    .home-recomm-services,
    .home-recomm-actives {
      @include flexCellCommon;
      height: $serviceItemsHeight;
    }
    .nhomepage-notices,
    .nhomepage-xigua-academy {
      @include flexCellCommon;
      .platform-notices {
        margin-bottom: $cardMargin;
      }
    }
    .nhomepage-xigua-academy {
      height: $academyHeight;
      .tbo-card-body {
        padding-top: 0 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// nhomepage.vue?4c07af59